import { render } from "./NoahMasterWorld.vue?vue&type=template&id=581419bf"
import script from "./NoahMasterWorld.vue?vue&type=script&lang=js"
export * from "./NoahMasterWorld.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__